import { defineStore } from 'pinia'

const resolveDefaultLang = () => {
  const nav = String(navigator.language || '').toLowerCase()
  if (nav.startsWith('zh')) return 'zh-CN'
  if (nav.startsWith('ja')) return 'ja-JP'
  return 'en-US'
}

export const useAppStore = defineStore('app', {
  state: () => ({
    deviceType: 'lg',
    isMobile: false,
    collapsed: false,
    lang: resolveDefaultLang(),
    badge: {} // 标记
  }),
  actions: {
    toggleDevice(deviceType, collapsed) {
      this.deviceType = deviceType
      this.isMobile = deviceType === 'xs'

      if (collapsed !== undefined) {
        this.collapsed = collapsed
      }
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setLanguage(lang) {
      this.lang = lang
    },
    mergeBadge(partial) {
      this.badge = { ...this.badge, ...partial }
    },
    reset() {
      this.$reset()
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        paths: ['collapsed', 'isFrame'],
        storage: sessionStorage
      },
      {
        paths: ['badge', 'lang'],
        storage: localStorage
      }
    ]
  }
})

export default useAppStore
